<a class="skip-link" [routerLink]="[]" fragment="main-content">Skip to main content</a>

<header class="navbar">
  <div class="navbar-inner">
    <a class="brand" [routerLink]="[routes.home.url]" (click)="closeMobile()" aria-label="VerifyDeceased home">
      <span class="brand-mark" aria-hidden="true">
        <svg viewBox="0 0 64 64" width="34" height="34" focusable="false">
          <defs>
            <linearGradient id="hdrShield" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stop-color="#7466cf" />
              <stop offset="1" stop-color="#372b78" />
            </linearGradient>
          </defs>
          <rect width="64" height="64" rx="16" fill="url(#hdrShield)" />
          <path d="M32 12 L48 18 V32 C48 42 41 49 32 52 C23 49 16 42 16 32 V18 Z"
            fill="#ffffff" fill-opacity="0.1" stroke="#fbdc70" stroke-width="1.8"
            stroke-linejoin="round" />
          <path d="M24 32 L30 38 L41 25" fill="none" stroke="#ffffff" stroke-width="4.2"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
      <span class="brand-text">
        <span class="brand-name">Verify<span class="brand-name-accent">Deceased</span></span>
        <span class="brand-parent">by LeadCruncher</span>
      </span>
    </a>

    <nav class="desktop-nav" aria-label="Primary">
      <a [routerLink]="[routes.howItWorks.url]" routerLinkActive="active">How it works</a>

      @if (isDashboardView()) {
        @for (item of roleNavItems; track item.link) {
          <a [routerLink]="[item.link]" routerLinkActive="active">{{ item.label }}</a>
        }
      } @else {
        <div class="nav-group">
          <button type="button" class="nav-trigger" aria-haspopup="true">
            Solutions
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="dropdown">
            <div class="dropdown-grid">
              @for (item of solutions; track item.link) {
                <a [routerLink]="[item.link]" class="dropdown-item">
                  <span class="dropdown-title">{{ item.label }}</span>
                  <span class="dropdown-desc">{{ item.description }}</span>
                </a>
              }
            </div>
            <a [routerLink]="[routes.solutions.url]" class="dropdown-foot">View all solutions</a>
          </div>
        </div>

        <a [routerLink]="[routes.pricing.url]" routerLinkActive="active">Pricing</a>
        <a [routerLink]="[routes.developers.url]" routerLinkActive="active">Developers</a>

        <div class="nav-group nav-group-end">
          <button type="button" class="nav-trigger" aria-haspopup="true">
            Resources
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div class="dropdown">
            <div class="dropdown-grid">
              @for (item of resources; track item.link) {
                <a [routerLink]="[item.link]" class="dropdown-item">
                  <span class="dropdown-title">{{ item.label }}</span>
                  <span class="dropdown-desc">{{ item.description }}</span>
                </a>
              }
            </div>
          </div>
        </div>
      }
    </nav>

    <div class="navbar-spacer"></div>

    <div class="navbar-actions">
      <a [href]="site.phoneHref" class="navbar-call">
        <span class="navbar-call-icon" aria-hidden="true">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" />
          </svg>
        </span>
        <span class="navbar-call-text">
          <span class="navbar-call-label">Call us today</span>
          <span class="navbar-call-num">{{ site.phone }}</span>
        </span>
      </a>

      @if (isLoggedIn) {
        @if (!isDashboardView()) {
          <a [routerLink]="[dashboardUrl]" class="btn btn-outline">Dashboard</a>
        }
        <button type="button" class="btn btn-primary" (click)="logout()">Logout</button>
      } @else {
        <a [routerLink]="[routes.bookACall.url]" class="btn btn-outline navbar-schedule">Schedule a call</a>
        <a [routerLink]="[routes.accountLogin.url]" class="navbar-login">Login</a>
        <a [routerLink]="[routes.accountRegister.url]" class="btn btn-primary">Get Started</a>
      }
    </div>

    <button type="button" class="mobile-toggle" (click)="toggleMobile()" aria-label="Toggle menu"
      [attr.aria-expanded]="mobileOpen()">
      @if (mobileOpen()) {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      } @else {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      }
    </button>
  </div>

  @if (mobileOpen()) {
    <div class="mobile-nav">
      <a [routerLink]="[routes.howItWorks.url]" (click)="closeMobile()">How it works</a>

      @if (isDashboardView()) {
        @for (item of roleNavItems; track item.link) {
          <a [routerLink]="[item.link]" (click)="closeMobile()">{{ item.label }}</a>
        }
      } @else {
        <button type="button" class="mobile-group-trigger" (click)="toggleGroup('solutions')">
          Solutions
          <span>{{ openGroup() === "solutions" ? "-" : "+" }}</span>
        </button>
        @if (openGroup() === "solutions") {
          <div class="mobile-sublinks">
            @for (item of solutions; track item.link) {
              <a [routerLink]="[item.link]" (click)="closeMobile()">{{ item.label }}</a>
            }
            <a [routerLink]="[routes.solutions.url]" (click)="closeMobile()">View all solutions</a>
          </div>
        }

        <a [routerLink]="[routes.pricing.url]" (click)="closeMobile()">Pricing</a>
        <a [routerLink]="[routes.developers.url]" (click)="closeMobile()">Developers</a>

        <button type="button" class="mobile-group-trigger" (click)="toggleGroup('resources')">
          Resources
          <span>{{ openGroup() === "resources" ? "-" : "+" }}</span>
        </button>
        @if (openGroup() === "resources") {
          <div class="mobile-sublinks">
            @for (item of resources; track item.link) {
              <a [routerLink]="[item.link]" (click)="closeMobile()">{{ item.label }}</a>
            }
          </div>
        }
      }

      <div class="mobile-actions">
        <a [href]="site.phoneHref" class="mobile-call" (click)="closeMobile()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" />
          </svg>
          Call us today: {{ site.phone }}
        </a>

        @if (isLoggedIn) {
          @if (!isDashboardView()) {
            <a [routerLink]="[dashboardUrl]" class="btn btn-outline btn-block" (click)="closeMobile()">Dashboard</a>
          }
          <button type="button" class="btn btn-primary btn-block" (click)="logout()">Logout</button>
        } @else {
          <a [routerLink]="[routes.bookACall.url]" class="btn btn-outline btn-block" (click)="closeMobile()">Schedule a call</a>
          <a [routerLink]="[routes.accountLogin.url]" class="btn btn-outline btn-block" (click)="closeMobile()">Login</a>
          <a [routerLink]="[routes.accountRegister.url]" class="btn btn-primary btn-block" (click)="closeMobile()">Get Started</a>
        }
      </div>
    </div>
  }
</header>
